module.exports = __webpack_public_path__ + "assets/img/tab2_09.eaa606f7.jpg";